import { useMemo } from 'react';
import useSWR from 'swr';
import LayerSwapApiClient from '../lib/apiClients/layerSwapApiClient';
import { resolveRoutesURLForSelectedToken } from '../helpers/routes';
/**
 * Fetches source routes available for a deposit-address flow to a given destination.
 * Uses the same URL builder as the form picker so the two share an SWR cache.
 */
export default function useDepositAddressSources({ destinationNetwork, destinationToken, enabled = true }) {
    const apiClient = useMemo(() => new LayerSwapApiClient(), []);
    const url = useMemo(() => {
        if (!enabled || !destinationNetwork || !destinationToken)
            return null;
        return resolveRoutesURLForSelectedToken({
            direction: 'from',
            network: destinationNetwork,
            token: destinationToken,
            includes: { unmatched: false, unavailable: false, swaps: true },
            hasDepositAddress: true,
            useDepositAddressSwaps: true,
            useFrontendSwap: true,
        });
    }, [enabled, destinationNetwork, destinationToken]);
    const { data, isLoading } = useSWR(url, apiClient.fetcher, { dedupingInterval: 10000, keepPreviousData: true });
    return { data, isLoading };
}
